class InfiniteScroll {
  constructor() {
    this.observer = null;
    this.loading = false;

    this.init();

    // Dawn replaces the product grid when filters/sorting are used.
    // Watch for those changes and reconnect infinite scrolling.
    this.mutationObserver = new MutationObserver(() => {
      this.init();
    });

    this.mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  init() {
    const trigger = document.querySelector('#InfiniteScroll');

    if (!trigger || trigger.dataset.observed === 'true') return;

    trigger.dataset.observed = 'true';

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.loadMore(trigger);
        }
      },
      {
        rootMargin: '600px 0px',
        threshold: 0
      }
    );

    this.observer.observe(trigger);
  }

  async loadMore(trigger) {
    if (this.loading) return;

    const nextUrl = trigger.dataset.nextUrl;

    if (!nextUrl) return;

    this.loading = true;
    trigger.classList.add('is-loading');

    try {
      const response = await fetch(nextUrl);

      if (!response.ok) {
        throw new Error('Unable to load more products');
      }

      const html = await response.text();

      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, 'text/html');

      const currentGrid = document.querySelector('#product-grid');
      const newGrid = newDocument.querySelector('#product-grid');
      const newTrigger = newDocument.querySelector('#InfiniteScroll');

      if (!currentGrid || !newGrid) {
        throw new Error('Product grid not found');
      }

      Array.from(newGrid.children).forEach((product) => {
        currentGrid.appendChild(product);
      });

      if (newTrigger && newTrigger.dataset.nextUrl) {
        trigger.dataset.nextUrl = newTrigger.dataset.nextUrl;
        trigger.dataset.observed = 'false';

        if (this.observer) {
          this.observer.disconnect();
        }

        this.loading = false;
        trigger.classList.remove('is-loading');

        this.init();
      } else {
        // No more pages
        if (this.observer) {
          this.observer.disconnect();
        }

        trigger.remove();
        this.loading = false;
      }
    } catch (error) {
      console.error('Infinite scroll error:', error);

      this.loading = false;
      trigger.classList.remove('is-loading');
      trigger.dataset.observed = 'false';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new InfiniteScroll();
});